export enum EventTypeVersion {
  V1 = 1,
  V2 = 2, // intervalMinutes handling logic changed https://github.com/jicoohq/web/pull/2513
  V3 = 3, // 2000 characters' length validation
  V4 = 4, // HubSpot integration logic changed
}
export const latestEventTypeVersion = EventTypeVersion.V4;
